export const formCopy = {
  labels: {
    email: 'Email',
    firstName: 'First name',
    lastName: 'Last name',
    name: 'Name',
    password: 'Password',
    projectName: 'Project name',
    search: 'Search',
    status: 'Status',
    workspaceName: 'Workspace name',
  },
  placeholders: {
    email: 'Enter your email',
    firstName: 'First name',
    headerName: 'Enter header name',
    lastName: 'Last name',
    password: 'Enter your password',
    projectName: 'Project name',
    search: 'Search',
    select: 'Select...',
    workspaceName: 'Workspace name',
  },
} as const;

export type FormLabelKey = keyof typeof formCopy.labels;
export type FormPlaceholderKey = keyof typeof formCopy.placeholders;

export const getFormLabel = (key: FormLabelKey): string => formCopy.labels[key];

export const getFormPlaceholder = (key: FormPlaceholderKey): string => formCopy.placeholders[key];

export const getSearchAriaLabel = (target: string): string => `Search ${target}`;

export const getFormCopySamples = (): string[] => [
  ...Object.values(formCopy.labels),
  ...Object.values(formCopy.placeholders),
  getSearchAriaLabel('projects'),
];
